import React, { useState, useEffect } from 'react'

import { usePageEditorContext } from '../../contexts/page-editor.context'
import { TextTableEditInline } from './text-table-edit-inline'
import { DataTableEditInline } from './data-table-edit-inline'
import { ItemCard } from '../../../common/components/item-card'
import { Button } from '../../../common/components/button'
import { TABLE_TYPE } from '../../blocks/table/table.constants'

import { useStyles } from './table-type-choice-block.style'

export const TableTypeChoiceBlock = function (props) {
  const { block } = props
  block.props = block.props || {}

  const classes = useStyles()
  const pageEditorContext = usePageEditorContext() || {}
  const [shouldDisplayChoice, setShouldDisplayChoice] = useState(block.props.subtype === TABLE_TYPE.UNKNOWN)

  useEffect(() => {
    if (shouldDisplayChoice) {
      pageEditorContext.setCurrentEdit({ block, isValid: false })
    }
  }, [shouldDisplayChoice])

  function chooseDataTable () {
    block.title = 'Sample Table'
    block.props.placeholder = true
    block.props.subtype = TABLE_TYPE.DATA
    pageEditorContext.savePage()
  }

  function chooseTextTable () {
    block.props.subtype = TABLE_TYPE.TEXT
    setShouldDisplayChoice(false)
    pageEditorContext.setCurrentEdit({ block, isValid: true })
  }

  if (shouldDisplayChoice) {
    return (
      <div className={classes.container}>
        <div>
          <div className={classes.choice}>
            <ItemCard className={classes.card}>
              <div className="flex-column flex-center-items">
                <div className="card-title">Data Table</div>
                <div className={classes.cardText}>A table that is dynamically populated by data</div>
                <Button type="button" variant="secondary" onClick={chooseDataTable} data-qa="choose-data">Choose Data</Button>
              </div>
            </ItemCard>
            <div className={classes.cardSeparator}>or</div>
            <ItemCard className={classes.card}>
              <div className="flex-column flex-center-items">
                <div className="card-title">Text Table</div>
                <div className={classes.cardText}>Static text table manually populated by user</div>
                <Button type="button" variant="secondary" onClick={chooseTextTable} data-qa="choose-text">Choose Text</Button>
              </div>
            </ItemCard>
          </div>
        </div>
      </div>
    )
  } else if (block.props.subtype === TABLE_TYPE.TEXT) {
    return (
      <TextTableEditInline {...props} />
    )
  } else {
    return (
      <DataTableEditInline block={pageEditorContext.currentEdit.block} />
    )
  }
}
